<template>
  <div class="container_presentation" v-if="course.name">
    <div class="spacer"></div>
    <div class="spacer"></div>
    <b-container>
      <b-row>
        <b-col md="3" class="side_logo_container">
          <img class="side_logo" src="@/assets/img/logo_rectangle_sm.png" alt="Logo challenge maritima" />
        </b-col>
        <b-col md="6">
          <h2 style="font-weight: bold">
            {{ course.name }}
            <!-- - {{ course.distance }} -->
          </h2>
          <h4>{{ course.date }} - Départ 9H30</h4>
        </b-col>
        <b-col md="3" class="side_logo_container">
          <img class="side_logo" src="@/assets/img/Logo_TotalEnergies.png" alt="Logo Total energies" />
        </b-col>
      </b-row>
      <b-row>
        <b-col offset-md="3" md="6">
          <div class="spacer"></div>
          <!-- <img src="@/assets/img/courses/parcours_castillon.jpg" alt="" />
          <div class="spacer"></div> -->
          <p>
            La course des étangs est l'événement phare de la rentrée sportive à Marignane.<br />

            Très attendue par les coureurs qui reprennent leur saison sportive après la trêve d’été, la course regroupe près de 500 participants qui se mesurent sur une épreuve de course de 10km.<br />

            Le parcours traverse des sites remarquables de la commune en longeant l’étang de Bolmon, passant par la base de sports et de loisirs de l’Estéou, le canal du Rove, le parc des 4 vents et l’étang de Berre.<br />

            Elle attire généralement un nombreux public qui vient encourager les sportifs de haut niveau mais aussi les joggeurs amateurs.
          </p>
          <p>Une course est ouverte aux personnes à mobilité réduite qui trouvent sur 5 km un parcours parfaitement adapté.</p>
        </b-col>
      </b-row>
      <div class="spacer"></div>
      <div class="spacer"></div>
      <b-row>
        <b-col md="2"></b-col>
        <b-col md="4">
          <img src="@/assets/img/courses/CDE1.jpg" alt="" />
        </b-col>
        <b-col md="4">
          <img :src="'https://sportips.fr/challenge-maritima/img/flyer/' + course.url_flyer" alt="" />
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col>
          <p><b>Contact : Stéphane DALIA</b></p>
        </b-col>
      </b-row>
      <div class="spacer"></div>
      <b-row>
        <b-col>
          <b-button class="infos_btn" download href="https://sportips.fr/challenge-maritima/uploads/Course des étangs parcours 10km.pdf" target="_blank">Plan du parcours</b-button>

          <b-button class="infos_btn" href="https://www.stadiumclub.fr/" target="_blank">Infos course</b-button>

          <b-button class="infos_btn" href="https://www.kms.fr/v5/public/" target="_blank">Inscriptions</b-button>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  props: ["course"],
  created() {},
};
</script>

<style lang="scss" scoped>
</style>